import React from "react";
import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { SidebarItemProps } from "../../types/interface";
import { COLORS } from "../../theme/colors";

const SidebarItem: React.FC<SidebarItemProps> = ({
  label,
  path,
  icon: Icon,
  collapsed,
  onClick,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = location.pathname === path;
  const isLogout = label === "Logout";

  const handleClick = () => {
    if (onClick) return onClick();
    if (path) navigate(path);
  };

  return (
    <ListItemButton
      onClick={handleClick}
      sx={{
        mx: 1.5,
        mb: 0.5,
        borderRadius: "10px",
        justifyContent: collapsed ? "center" : "flex-start",

        color: isLogout
          ? "#ef4444"
          : isActive
            ? COLORS.primary
            : COLORS.textSecondary,

        backgroundColor: isLogout
          ? "rgba(239,68,68,0.08)"
          : isActive
            ? COLORS.sidebarActive
            : "transparent",

        "&:hover": {
          backgroundColor: isLogout
            ? "rgba(239,68,68,0.15)"
            : COLORS.sidebarActive,
        },
      }}
    >
      <ListItemIcon
        sx={{
          minWidth: 0,
          mr: collapsed ? 0 : 1.5,
          justifyContent: "center",
          color: "inherit",
        }}
      >
        <Icon fontSize="small" />
      </ListItemIcon>

      {!collapsed && (
        <ListItemText
          primary={label}
          slotProps={{
            primary: {
              sx: {
                fontSize: "14px",
                fontWeight: isActive ? 600 : 500,
              },
            },
          }}
        />
      )}
    </ListItemButton>
  );
};

export default SidebarItem;
